// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__1V7Re"};